function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 0C9.01099 0 0 9.01099 0 20C0 31.0989 9.01099 40 20 40C31.0989 40 40 30.989 40 20C40 9.01099 31.0989 0 20 0ZM20 5.93407C23.6264 5.93407 26.5934 8.9011 26.5934 12.5275C26.5934 16.1538 23.6264 19.1209 20 19.1209C16.3736 19.1209 13.4066 16.1538 13.4066 12.5275C13.4066 8.9011 16.3736 5.93407 20 5.93407ZM20 34.8352C16.3736 34.8352 12.967 33.5165 10.4396 31.3187C9.78022 30.7692 9.45055 30 9.45055 29.1209C9.45055 25.3846 12.4176 22.4176 16.1538 22.4176H23.8462C27.5824 22.4176 30.5494 25.3846 30.5494 29.1209C30.5494 30 30.2198 30.7692 29.5604 31.3187C27.033 33.5165 23.6264 34.8352 20 34.8352Z",
  fill: "#B3E7E3"
});

var SvgIcAvatar = function SvgIcAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_avatar.195aa02b.svg";
export { ForwardRef as ReactComponent };